import React from 'react';
import { Box, BlockStack } from '@shopify/polaris';
import { useLanguage } from '../context/LanguageContext';
import { usePageT } from '../i18n/createT';
import { COMMON_T } from '../i18n/commonT';

/**
 * Placeholder affiché pendant le chargement d'une route (Suspense ou transition).
 * Évite l'écran blanc entre deux pages.
 */
export default function PageRouteFallback({ overlay = false }) {
  const { lang } = useLanguage();
  const t = usePageT(COMMON_T, lang);

  return (
    <div
      className={`kio-page-route-fallback${overlay ? ' kio-page-route-fallback--overlay' : ''}`}
      role="status"
      aria-live="polite"
      aria-label={t.page_loading}
    >
      <Box padding="400" paddingBlockStart="500">
        <BlockStack gap="500">
          <div className="kio-skeleton" style={{ height: 32, width: 'min(280px, 55%)', borderRadius: 8 }} />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
              gap: 16,
            }}
          >
            {[0, 1, 2, 3].map((i) => (
              <div
                key={i}
                className="kio-skeleton"
                style={{ height: 88, borderRadius: 12 }}
              />
            ))}
          </div>
          <div className="kio-skeleton" style={{ height: 48, borderRadius: 12 }} />
          <BlockStack gap="150">
            {Array.from({ length: 8 }, (_, i) => (
              <div
                key={i}
                className="kio-skeleton"
                style={{ height: 44, borderRadius: 8 }}
              />
            ))}
          </BlockStack>
        </BlockStack>
      </Box>
    </div>
  );
}
